import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    types : [],
    loaded : false,
    addNew : false,
})

  // getters
  const getters = {
    getIdByName: (state) => (name) =>{
        return state.types.find(type => type.name == name);
    },
  }

  // actions
  const actions = {
    async loadAdresstypes({commit, state, rootState}){
        await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/addresstypes").then((response) => {
            commit("setTypes", response.data.data);
            commit("loaded", true);
        })
    }
  }

  // mutations
  const mutations = {
    clean(state){
      state.types = [];
      state.loaded = false;
    },
      setTypes(state, values){
        state.types = values;
      },
      loaded(state, status){
          state.loaded = status;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
